import React from "react";
import { useTranslation } from "react-i18next";
import { StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useSnapshot } from "valtio";

import CardFooterModalPublish from "./CardFooterModalPublish";

import { store, setIsModesModalPublishOpened } from "../../../store/project";

import { capitalize } from "@helpers/general";

type ModalPublishType = {
    rowData: any;
    setIsModalLoadingOpened: Function;
    setModalLoadingData: Function;
    setIsDataUpdated: Function;
};

export default function ModalPublish({
    rowData,
    setIsModalLoadingOpened,
    setModalLoadingData,
    setIsDataUpdated,
}: ModalPublishType) {
    const { t } = useTranslation();

    const { isModesModalPublishOpened } = useSnapshot(store);

    return (
        <React.Fragment>
            <Modal centered isOpen={isModesModalPublishOpened}>
                <ModalHeader
                    toggle={() => {
                        setIsModesModalPublishOpened!(
                            !isModesModalPublishOpened
                        );
                    }}
                >
                    <StyledH2>
                        {capitalize(t("Release configuration"))}
                    </StyledH2>
                </ModalHeader>
                <ModalBody>
                    <StyledLabel className="pl-3 m-0">
                        {t("Please confirm the publication of this template")} !
                    </StyledLabel>
                </ModalBody>
                <CardFooterModalPublish
                    rowData={rowData}
                    setIsModalLoadingOpened={setIsModalLoadingOpened}
                    setModalLoadingData={setModalLoadingData}
                    setIsModesModalPublishOpened={setIsModesModalPublishOpened}
                    setIsDataUpdated={setIsDataUpdated}
                />
            </Modal>
        </React.Fragment>
    );
}
